const ServiceConfig = {
  BLACKLIST: ["activeRuns", "history", "historySummary"]
};

module.exports = ServiceConfig;



// WEBPACK FOOTER //
// ./src/js/constants/JobConfig.js